if (!customElements.get('localization-form')) {
  // Check if we're in the theme editor to prevent redirect issues
  const isInThemeEditor = window.Shopify && window.Shopify.designMode;
  
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        window.addEventListener('click', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        
        // Using our isInThemeEditor variable to prevent redirect issues
        if (isInThemeEditor) {
          console.log('Language changed in theme editor - preventing redirect');
          // In theme editor mode, we'll avoid submitting the form
          this.hidePanel();
          // Showing feedback to the user that something happened
          const button = this.elements.button;
          const originalText = button.textContent || '';
          button.textContent = 'Language changed';
          setTimeout(() => { button.textContent = originalText; }, 1500);
        } else {
          // Normal operation outside the theme editor
          if (form) form.submit();
        }
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }

      closeSelector(event) {
        if (event.target.classList.contains('localization-form__select')) return;
        if (event.target.closest('.localization-form__select')) return;
        this.hidePanel();
      }
    }
  );
}
